import React from 'react';
import { ExternalLink } from 'lucide-react';
const listings = [{
  id: 1,
  address: '1428 Pacific Ave',
  city: 'San Francisco',
  price: '$2.45M',
  beds: 4,
  baths: 3.5,
  sqft: '2,850',
  status: 'Active',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=200&h=200&fit=crop'
}, {
  id: 2,
  address: '850 Marina Blvd',
  city: 'San Francisco',
  price: '$3.1M',
  beds: 3,
  baths: 2,
  sqft: '2,100',
  status: 'Coming Soon',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=200&h=200&fit=crop'
}, {
  id: 3,
  address: '245 Cole St',
  city: 'San Francisco',
  price: '$1.9M',
  beds: 3,
  baths: 2.5,
  sqft: '1,950',
  status: 'Open House',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600607687931-cebf004f560c?w=200&h=200&fit=crop'
}, {
  id: 4,
  address: '72 Belvedere Ave',
  city: 'Mill Valley',
  price: '$4.2M',
  beds: 5,
  baths: 4,
  sqft: '3,800',
  status: 'Active',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=200&h=200&fit=crop'
}, {
  id: 5,
  address: '1100 Sacramento St',
  city: 'San Francisco',
  price: '$1.65M',
  beds: 2,
  baths: 2,
  sqft: '1,400',
  status: 'Active',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600573472591-ee6b68d14c68?w=200&h=200&fit=crop'
}, {
  id: 6,
  address: '330 Divisadero St',
  city: 'San Francisco',
  price: '$2.1M',
  beds: 3,
  baths: 2,
  sqft: '2,200',
  status: 'Pending',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=200&h=200&fit=crop'
}, {
  id: 7,
  address: '88 King St #1205',
  city: 'San Francisco',
  price: '$1.35M',
  beds: 2,
  baths: 2,
  sqft: '1,150',
  status: 'Active',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=200&h=200&fit=crop'
}, {
  id: 8,
  address: '415 Bridgeway',
  city: 'Sausalito',
  price: '$3.8M',
  beds: 4,
  baths: 3,
  sqft: '3,200',
  status: 'Coming Soon',
  link: '#',
  image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=200&h=200&fit=crop'
}];
const statusStyles: Record<string, string> = {
  Active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Coming Soon': 'bg-amber-50 text-amber-700 border-amber-200',
  'Open House': 'bg-blue-50 text-blue-700 border-blue-200',
  Pending: 'bg-gray-100 text-gray-600 border-gray-200'
};
export function ActiveListings() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px]" data-id="element-21">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-6 gap-3" data-id="element-22">
        <div data-id="element-23">
          <h2 className="text-2xl font-serif text-brand-dark mb-1" data-id="element-24">
            Current listings
          </h2>
          <p className="text-sm text-brand-muted" data-id="element-25">
            Active and upcoming properties
          </p>
        </div>
        <button className="text-sm text-brand-dark font-medium hover:text-brand-forest transition-colors inline-flex items-center" data-id="element-26">
          View all <span className="ml-1" data-id="element-27">→</span>
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-28">
        {listings.map(listing => <a key={listing.id} href={listing.link} className="flex gap-3 p-3 bg-white rounded-xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-29">
            <div className="w-16 h-16 rounded-lg overflow-hidden shrink-0" data-id="element-30">
              <img src={listing.image} alt={listing.address} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-31" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-32">
              <div className="flex items-center justify-between mb-1" data-id="element-33">
                <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full border leading-tight ${statusStyles[listing.status] || statusStyles['Active']}`} data-id="element-34">
                  {listing.status}
                </span>
                <ExternalLink size={12} className="text-brand-muted opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-35" />
              </div>
              <p className="font-mono text-sm font-medium text-brand-dark" data-id="element-36">
                {listing.price}
              </p>
              <p className="text-xs text-brand-dark truncate" data-id="element-37">
                {listing.address}, {listing.city}
              </p>
              <div className="flex items-center gap-2 text-[10px] text-brand-muted font-mono mt-0.5" data-id="element-38">
                <span data-id="element-39">{listing.beds}bd</span>
                <span data-id="element-40">{listing.baths}ba</span>
                <span data-id="element-41">{listing.sqft}sf</span>
              </div>
            </div>
          </a>)}
      </div>
    </section>;
}